module.exports = __webpack_public_path__ + "static/media/02_CALCINHA_LATERAL_DRAPEADA_LISA_04.9dbccb0c.jpg";